var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HeaderDashboardCards,{attrs:{"data-testid":"responsibilities-header-dashboard","aria-label":"Responsibilities summary","metrics":_setup.cards,"variant":"count-only","columns":5,"action-label":_vm.activeIndicator ? 'Clear Filter' : 'Apply Filter'},on:{"select":_setup.handleSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }